<template>
  <el-container>
    <el-header class="table-header">
      <router-link :to="{name: 'roleAdd'}">
          <el-button type="primary" size="mini">{{$t('common.Add')}}</el-button>
      </router-link>
        <el-button icon="el-icon-search" @click="search(form)" align="center" size="mini">{{$t('common.Search')}}</el-button>
        <el-button icon="el-icon-refresh-left" @click="reset" align="center" size="mini">{{$t('common.Reset')}}</el-button>
    </el-header>
    <el-main class="table-main">
      <el-form :model="form" label-width="80px" size="mini" class="table-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('base.info.role.RoleCode')">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.role.RoleName')">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Type')">
              <el-select v-model="form.type" :placeholder="$t('common.PleaseChoose')" @change="clickValue">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="tableData" border stripe
        style="width: 100%">
        <el-table-column
          type="index">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="150" v-if="false">
        </el-table-column>
        <el-table-column
          prop="code"
          :label="$t('common.Code')"
          align="center"
          width="100%">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('common.Name')"
          align="center"
          width="180%">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('common.Type')"
          align="center"
          width="180%">
          <template slot-scope="scope">
            <span v-if="scope.row.type===50" size="small">{{$t('base.info.role.OnlineRegister')}}</span>
            <span v-if="scope.row.type===20" size="small">{{$t('base.info.role.Custom')}}</span>
            <span v-if="scope.row.type===10" size="small">{{$t('base.info.role.SystemRetention')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('common.Status')"
          align="center"
          width="90%">
          <template slot-scope="scope">
            <span v-if="scope.row.status===50">{{$t('common.Normal')}}</span>
            <span v-if="scope.row.status===40">{{$t('common.Disable')}}</span>
            <span v-if="scope.row.status===10">{{$t('common.Draft')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          :label="$t('common.Remark')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="modifyTime"
          :label="$t('common.ModifyTime')"
          :formatter="dateFormat"
          align="center"
          width="200%">
        </el-table-column>
        <el-table-column
          fixed="right"
          width="200%"
          align="center"
          :label="$t('common.Operate')">
          <template slot-scope="scope">
            <router-link :to="{name: 'roleEdit', params: {row:scope.row}}">
              <el-button size="mini" type="text">{{$t('common.Edit')}}</el-button>
            </router-link>
            <el-button type="text" size="mini" @click="deleteRow(scope.row)">{{$t('common.Delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="table-footer">
      <table-page ref="roleListPage" :url="roleListUrl" :form="form" @page-change="convert"></table-page>
    </el-footer>
  </el-container>
</template>

<script>
import moment from 'moment'
import TablePage from '@/components/TablePage'

export default {
  data () {
    return {
      form: {},
      tableData: [],
      type: 0,
      roleListUrl: this.global.BASE_ACL + '/role/findAllRole',
      options: [{
        label: this.$t('common.PleaseChoose')
      }, {
        value: 10,
        label: this.$t('base.info.role.SystemRetention')
      }, {
        value: 20,
        label: this.$t('base.info.role.Custom')
      }, {
        value: 50,
        label: this.$t('base.info.role.OnlineRegister')
      }],
      value: ''
    }
  },
  components: {
    TablePage
  },
  methods: {
    search (param) {
      this.$refs['roleListPage'].getTableData(param)
    },
    deleteRow (row) {
      this.$confirm(this.$t('common.DeleteConfirm'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.roleList.roleDelete(this.qs.stringify({id: row.id}))
          .then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
            this.$refs['roleListPage'].getTableData()
          }).catch((error) => {
            console.log(error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.Cancel')
        })
      })
    },
    reset () {
      this.form = {}
    },
    clickValue () {
      this.type = this.value
    },
    convert (table) {
      this.tableData = table.data
    },
    // 时间格式化
    dateFormat (row, column) {
      let date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/roleList.vue